import type { Component } from 'vue';
import { User } from '@/modules/user/models/User';

export class TributeConfig {
  element: Element;
  mentionables: User[];
  trigger: string;
  mentionOptionComponent: Component;
  triggerLength: number;
  mentionableLookupField: string;
  onMention: () => void;
  onShowMentions: () => void;
  onHideMentions: () => void;

  constructor(config: Partial<TributeConfig> = {}) {
    this.element = config.element as Element;
    this.mentionables = config.mentionables as User[];
    this.trigger = config.trigger ?? '@';
    this.mentionOptionComponent = config.mentionOptionComponent as Component;
    this.triggerLength = config.triggerLength ?? 0;
    this.mentionableLookupField = config.mentionableLookupField as string;
    this.onMention = config.onMention as () => void;
    this.onShowMentions = config.onShowMentions as () => void;
    this.onHideMentions = config.onHideMentions as () => void;
  }
}
